import React from "react";
import { Theme } from "../constants/colors";

interface ThemeToggleProps {
  theme: Theme;
  onToggle: () => void;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  theme,
  onToggle,
}) => {
  return (
    <button
      onClick={onToggle}
      className="p-2 rounded-full hover:bg-opacity-20 hover:bg-black dark:hover:bg-white transition-colors duration-300"
      aria-label="Toggle theme"
    >
      {theme === "light" ? (
        <span className="text-xl">🌙</span>
      ) : (
        <span className="text-xl">☀️</span>
      )}
    </button>
  );
};
